

// 网购换货——淘宝，主流程
const tbMainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `change/tb/index${i + 1}`,
  name: `changeTbIndex${i + 1}`,
  component: () => import(`@/views/shopping/change/tb/index${i + 1}.vue`),
}));
// 网购换货——京东，主流程
const jdMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `change/jd/index${i + 1}`,
  name: `changeJdIndex${i + 1}`,
  component: () => import(`@/views/shopping/change/jd/index${i + 1}.vue`),
}));

// 网购换货——拼多多，主流程
const pddMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `change/pdd/index${i + 1}`,
  name: `changePddIndex${i + 1}`,
  component: () => import(`@/views/shopping/change/pdd/index${i + 1}.vue`),
}));


// 网购换货——抖音，主流程
const dyMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `change/dy/index${i + 1}`,
  name: `changeDyIndex${i + 1}`,
  component: () => import(`@/views/shopping/change/dy/index${i + 1}.vue`),
}));


export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    // 网购换货——淘宝，主流程
    ...tbMainRoutes,
    // 网购换货——京东，主流程
    ...jdMainRoutes,

    // 网购换货——拼多多，主流程
    ...pddMainRoutes,

    // 网购换货——抖音，主流程
    ...dyMainRoutes,

  ],
};
